import { authEndpoints } from "@/constants";
import { axiosClient, removeTokenHandler } from "@/services/axios-client";

export const logoutHandler = async (): Promise<void> => {
    try {
        await axiosClient.post(authEndpoints.logout);
    } finally {
        removeTokenHandler();
    }
};
